export default __webpack_public_path__ + "static/media/adawms_logo2.ce5bf312.png";